<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.view_feature_data") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #446e80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <!-- Start:: Image Display -->
          <div class="12" v-if="data.image">
            <div class="input_wrapper d-flex flex-column align-items-center">
              <label>{{ $t("PLACEHOLDERS.feature_image") }}</label>
              <div class="image_preview_wrapper">
                <img
                  :src="data.image"
                  :alt="data.name_ar"
                  style="max-width: 200px; border-radius: 8px"
                />
              </div>
            </div>
          </div>
          <!-- End:: Image Display -->
          <!-- Start:: Name AR Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.name_ar"
            disabled
          />
          <!-- End:: Name AR Input -->

          <!-- Start:: Name EN Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.name_en"
            disabled
          />
          <!-- End:: Name EN Input -->

          <!-- Start:: Description AR Input -->
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionAr')"
            v-model.trim="data.description_ar"
            disabled
          />
          <!-- End:: Description AR Input -->

          <!-- Start:: Description EN Input -->
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionEn')"
            v-model.trim="data.description_en"
            disabled
          />
          <!-- End:: Description EN Input -->

          <!-- Start:: Created At Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.created_at')"
            v-model.trim="data.created_at"
            disabled
          />
          <!-- End:: Created At Input -->

          <!-- Start:: Activation Switch Input -->
          <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="
                data.is_active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.is_active"
              hide-details
              disabled
            ></v-switch>
          </div>
          <!-- End:: Activation Switch Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "ShowFeature",

  data() {
    return {
      // Start:: Data Collection
      data: {
        name_ar: null,
        name_en: null,
        description_ar: null,
        description_en: null,
        image: null,
        created_at: null,
        is_active: true,
      },
      // End:: Data Collection
    };
  },

  methods: {
    // Start:: Get Data
    async getData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `features/${this.$route.params.id}`,
        });
        this.data.name_ar = res.data.data?.data.name_ar;
        this.data.name_en = res.data.data?.data.name_en;
        this.data.description_ar = res.data.data?.data.description_ar;
        this.data.description_en = res.data.data?.data.description_en;
        this.data.image = res.data.data?.data.image;
        this.data.created_at = res.data.data?.data.created_at;
        this.data.is_active = res.data.data?.data.is_active;
      } catch (error) {
        console.log(error?.response?.data?.message);
      }
    },
    // End:: Get Data
  },

  created() {
    this.getData();
  },
};
</script>
